export const SINGLE_POST_OPEN = 'SINGLE_POST_OPEN';
export const SINGLE_POST_CLOSE = 'SINGLE_POST_CLOSE';

export const INCREMENT_LIKES = 'INCREMENT_LIKES';


export const SHOW_COMMENTS = 'SHOW_COMMENTS';
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const DELETE_COMMENTS = 'DELETE_COMMENTS';



// WEBPACK FOOTER //
// ./src/Store/Actions/ActionTypes.js